// Microsoft does not document a task URL in Graph; this is the link Planner on the web shows for a task.
export function plannerTaskUrl(task, tenantId) {
  const url = `https://planner.cloud.microsoft/webui/plan/${encodeURIComponent(task.planId)}/view/board/task/${encodeURIComponent(task.id)}`
  return tenantId ? `${url}?tid=${encodeURIComponent(tenantId)}` : url
}

// Planner, Teams and the older tasks.office.com links each put the plan ID in a different place.
export function planIdFromInput(input) {
  const text = input.trim()
  if (/^[A-Za-z0-9_-]{16,100}$/.test(text)) return text
  let decoded = text
  try { decoded = decodeURIComponent(text) } catch { /* keep the raw link */ }
  const match = decoded.match(/(?:[?&#]planId=|\/plan\/|\/PlanViews\/)([A-Za-z0-9_-]{16,100})/)
  return match ? match[1] : null
}
